import { render, staticRenderFns } from "./rsForm.vue?vue&type=template&id=5186fb48"
import script from "./rsForm.vue?vue&type=script&lang=js"
export * from "./rsForm.vue?vue&type=script&lang=js"
import style0 from "./rsForm.vue?vue&type=style&index=0&id=5186fb48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports